import React from "react";
import "./Intro.css";

const Intro = () => {
  return (
    <div className="intro-container">
      <h1 className="intro-name">Jason Kobuchi</h1>
      <h3 className="intro-title">Frontend Developer & Data Analyst</h3>
    </div>
  );
};

export default Intro;
